import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { CopyBillBookingRequest } from 'src/app/core/models/transport-operation/copy-bill-booking-request';
import { CopyBillBookingResponse } from 'src/app/core/models/transport-operation/copy-bill-booking-response';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { isNullOrEmpty, laaSFormatString } from 'src/app/core/utils/common-functions';
import { BookingService } from 'src/app/features/transport-operation/services/booking.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

@Component({
  selector: 'laas-redelivery-booking',
  templateUrl: './redelivery-booking.component.html',
  styleUrls: ['./redelivery-booking.component.scss']
})
export class RedeliveryBookingComponent extends SessionBaseComponent implements OnInit {

  @Output() onClose = new EventEmitter<boolean>();
  @Input() display: boolean;

  @Input() redeliveryBookingNoList!: string[];
  @Input() bookingNoListString!: string;
  @Input() copyBillingBookingRequest : CopyBillBookingRequest;

  redeliveryCount: number;
  bookingForwarderList: any[];

  constructor(injector: Injector, private bookingService: BookingService, private dropdownOptionService: DropdownOptionsService) {
    super(injector);
    this.display = false;
    this.bookingNoListString = '';
    this.redeliveryCount = 1;
    this.copyBillingBookingRequest = {
      facility: this.laasSetting.facility,
      doNoList: [],
      createUser: '',
      originBookingNo: null,
      redeliveryCount: 1,
      successFlag: false,
      newBooking: null,
      originBookingForwarder: null
    };
    this.bookingForwarderList = [];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();


    this.bookingNoListString = '';

    this.dropdownOptionService.getForwarderOptions().subscribe({
      next: (result) => {
        this.bookingForwarderList = result;
      }
    });

  }


  hideDialog(event: any): void {
    this.onClose.emit(this.display);
  }

  showDialog(event: any): void {
  }

  saveBtnClick(): void {

    let newBookingNo: string;
    let copyBillBookingSuccessMessage: string;

    this.copyBillingBookingRequest.redeliveryCount = this.redeliveryCount
    this.loader.show();
    this.bookingService.copyBillBooking(this.copyBillingBookingRequest).subscribe({
      next: (response) => {
        let resp: CopyBillBookingResponse = response;
        newBookingNo = resp.newBookingNo;

        copyBillBookingSuccessMessage = this.translateService.instant(
          'BookingSearch.Message.CopyBillBookingSuccessMessage'
        );

        let copyBillBookingSuccessReplaceMessage = `${laaSFormatString(copyBillBookingSuccessMessage, [newBookingNo])}\n`
        this.toastService.success(copyBillBookingSuccessReplaceMessage);
        this.display = false;
        this.copyBillingBookingRequest.successFlag = true;
        this.copyBillingBookingRequest.newBooking = newBookingNo;
        this.onClose.emit(this.display);
      },
      error: (err) => {
        let matchedError = err.error
        if (!isNullOrEmpty(matchedError.errorMsg)) {
          this.toastErrorMessage(matchedError.errorMsg);
        } else {
          this.toastErrorMessage(err.errorMsg);
        }
        this.copyBillingBookingRequest.successFlag = false;
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
        this.display = false;
        this.onClose.emit(this.display);
      },
    });

  }

}
